// extracted by mini-css-extract-plugin
export default {"boxPlot":"box_plot_boxPlot__0bNKT","whiskers":"box_plot_whiskers__fykJE","box":"box_plot_box__IdeKA","circle":"box_plot_circle__dPH4t"};